import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'

export const NEARBY_LOADS_ACTION_TYPES = generateApiActionTypes('NEARBY_LOADS')
export const getNearbyLoads = (id: number | string) => {
  const requestData = {
    endpoint: ENDPOINTS.shipments,
    id,
    group: 'nearby_pickup_shipments',
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(NEARBY_LOADS_ACTION_TYPES),
    },
  }
}

export const RELOADS_ACTION_TYPES = generateApiActionTypes('RELOADS')
export const getReloads = (id: number | string) => {
  const requestData = {
    endpoint: ENDPOINTS.shipments,
    id,
    group: 'reload_shipments',
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(RELOADS_ACTION_TYPES),
    },
  }
}
